/**
 * Country
 */

component_notification({

  shouldShowNotification: () => {

    try {
      if (window.sessionStorage.getItem('country_notice_dismissed')) {
        return false;
      }
    } catch (e) {}

    var userLang = navigator.language || navigator.userLanguage;
    var siteLang = document.documentElement.lang;

      if (siteLang == 'en-GB' || siteLang == 'en-US' || siteLang == 'en') {
        if (userLang == 'da-DK' || userLang == 'da') {
          return true;
        }
        if (userLang == 'fi-FI' || userLang == 'fi') {
          return true;
        }
        if (userLang == 'sv-SE' || userLang == 'sv') {
          return true;
        }
      } else {
        // auto-dismiss if user doesn't land to group site first
        window.sessionStorage.setItem('country_notice_dismissed', 1);
      }


    return false;

  },

  afterClosingNotification: () => {

    try {
      window.sessionStorage.setItem('country_notice_dismissed', 1);
    } catch (e) {
      // localStorage not available
    }

  },
  afterShowingNotification: () => {

  },
  notificationHTML: () => {

      var userLang = navigator.language || navigator.userLanguage;

      if (userLang == 'fi-FI' || userLang == 'fi') {
        var noticeStrings = {
          msg: 'Hei! Onko hakusessa Generaxion Finland?',
          url: '/fi/',
          btn: 'Generaxion Finland'
        };
      } else if (userLang == 'sv-SE' || userLang == 'sv') {
        var noticeStrings = {
          msg: 'Hallå! Letar du efter Generaxion Sweden?',
          url: '/se/',
          btn: 'Generaxion Sweden'
        };
      } else {
        var noticeStrings = {
          msg: 'Hej! Leder du efter Generaxion Denmark?',
          url: '/dk/',
          btn: 'Generaxion Denmark'
        };
      }

    return '<a href="' + noticeStrings.url + '"><span class="screen-reader-text">' + noticeStrings.btn + '</span></a><span class="notification__text">' + noticeStrings.msg + '</span><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" /></svg>';
  },
  notificationClass: () => 'notification--country'
});
